/**
 * View toggle (Globe vs Table) in the filter bar: swaps the active view, drives
 * the sliding header label, and pauses/resumes the globe. Extracted verbatim
 * from the globe client monolith (Phase 3). Collapsing the filter panel is
 * delegated to the injected helper from the filter accordion.
 */
/* eslint-disable */
export interface ViewToggleDeps {
  collapseFilterContentIfExpanded: () => void
}

export function initViewToggle(deps: ViewToggleDeps): void {
    var collapseFilterContentIfExpanded = deps.collapseFilterContentIfExpanded;

    var filterGlobeViewBtn = document.getElementById('filter-globe-view-btn');
    var filterTableViewBtn = document.getElementById('filter-table-view-btn');
    var globeWrapper = document.querySelector('.globe-wrapper');
    var tableView = document.getElementById('table-view');
    var filterHeaderLabelTrack = document.getElementById('filter-header-label-track');
    var filterViewToggle = document.getElementById('filter-view-toggle');

    var LABEL_LINE_HEIGHT_PX = 17;

    function setLabelDisplay(index) {
      if (filterHeaderLabelTrack) {
        filterHeaderLabelTrack.style.transform = 'translateY(-' + (index * LABEL_LINE_HEIGHT_PX) + 'px)';
      }
    }

    function getActiveLabelIndex() {
      if (filterTableViewBtn && filterTableViewBtn.classList.contains('active')) return 1;
      return 0;
    }

    function switchToGlobeView() {
      if (filterGlobeViewBtn && filterGlobeViewBtn.classList.contains('active')) return;
      collapseFilterContentIfExpanded();
      if (filterGlobeViewBtn) filterGlobeViewBtn.classList.add('active');
      if (filterTableViewBtn) filterTableViewBtn.classList.remove('active');
      setLabelDisplay(0);
      if (globeWrapper) globeWrapper.classList.remove('table-view-active');
      if (tableView) tableView.setAttribute('aria-hidden', 'true');
      if (window.globe) {
        window.globe.handleResize();
        window.globe.resume();
      }
    }

    function switchToTableView() {
      if (filterTableViewBtn && filterTableViewBtn.classList.contains('active')) return;
      collapseFilterContentIfExpanded();
      // Defer the morph one frame so the bar's collapsed height (82px) commits
      // before the table-view rule swaps it to a numeric full height. This lets the
      // CSS height transition animate instead of snapping from intrinsic fit-content.
      requestAnimationFrame(function() {
        if (window.globe) window.globe.pause();
        if (filterGlobeViewBtn) filterGlobeViewBtn.classList.remove('active');
        if (filterTableViewBtn) filterTableViewBtn.classList.add('active');
        setLabelDisplay(1);
        if (globeWrapper) globeWrapper.classList.add('table-view-active');
        if (tableView) tableView.setAttribute('aria-hidden', 'false');
      });
    }

    if (filterGlobeViewBtn) filterGlobeViewBtn.addEventListener('click', switchToGlobeView);
    if (filterTableViewBtn) filterTableViewBtn.addEventListener('click', switchToTableView);

    if (filterGlobeViewBtn) {
      filterGlobeViewBtn.addEventListener('mouseenter', function() {
        if (getActiveLabelIndex() !== 0) setLabelDisplay(0);
      });
    }
    if (filterTableViewBtn) {
      filterTableViewBtn.addEventListener('mouseenter', function() {
        if (getActiveLabelIndex() !== 1) setLabelDisplay(1);
      });
    }
    if (filterViewToggle) {
      filterViewToggle.addEventListener('mouseleave', function() {
        setLabelDisplay(getActiveLabelIndex());
      });
    }
}
